// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__ueBX-","label":"SetPasswdForm_label__1T4zs"};